import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Travel.css";
import {
  LayoutMain,
  Background,
  MainHeadline,
  TemplateOffer,
  Textsection,
  InfoOffer,
  NoOfferFound,
} from "../../components/common";
import { Row, Col } from "react-bootstrap";
import offers from "../../data/offersTravel";
import { Divider } from "../../components/styles";

const Travel = ({ headline = "REISEN" }) => {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;
  const [selectedOffer, setSelectedOffer] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // clear offer selection whenever we land on the main page
    // (independent of load/unload):
    if (location.pathname === "/travel") {
      setSelectedOffer(null);
    }
  }, [location.pathname]);

  // useEffect for opening cards displayed at homepage
useEffect(() => {
  if (location.state?.offerId) {
    const offer = offers.find((o) => o.id === location.state.offerId);
    if (offer) setSelectedOffer(offer);
  }
}, [location.state]);

  const handleOfferClick = (id) => {
    const selectedOffer = offers.find((offer) => offer.id === id);
    // add a (dummy) page to history stack to navigate back properly:
    navigate(`/travel/offer`);
    setSelectedOffer(selectedOffer);
  };

  const handleBookingClick = (id) => {
    navigate(`/travel`); // return here after navigating back from booking
    navigate(`/booking/${id}`); // Navigate to the booking page with offerId as a URL parameter
  };
  const handleReturnClick = () => {
    navigate(`/travel`);
  };

  return (
    <LayoutMain>
      <Background image={`${baseImagePath}travel/background/img_travel1.jpg`}>
        <MainHeadline text={headline} />
      </Background>
      <Textsection>
        {!selectedOffer ? (
          <section className="travel-ma in">
            <div className="travel-wrapper">
              <div className="travel-content">
                <h1>Österreich entdecken</h1>
                <p>
                  Die Alpen in Österreich bieten atemberaubende
                  Berglandschaften, spannende Wanderwege und unvergessliche
                  Naturerlebnisse. Ob Wandern, Klettern oder Skifahren – für
                  Outdoor-Enthusiasten ist hier alles dabei. Die majestätischen
                  Gipfel und malerischen Täler laden dazu ein, die Schönheit der
                  Natur in vollen Zügen zu genießen.
                </p>
              </div>

              <Divider text="Österreich" />

              <div className="travel-offer">
                <Row>
                  {offers
                    .filter((offer) => offer.country === "Österreich")
                    .map((offer) => (
                      <Col key={offer.id} xs={12} sm={6} md={4}>
                        <TemplateOffer
                          imgHead={offer.imgHead}
                          title={offer.title}
                          subtitle={offer.subtitle}
                          text={offer.text_overview}
                          price={offer.price}
                          duration={offer.duration}
                          maxGuests={offer.maxGuests}
                          overalleLevel={offer.overalleLevel}
                          onMehrClick={() => handleOfferClick(offer.id)}
                          onBuchenClick={() => handleBookingClick(offer.id)}
                        />
                      </Col>
                    ))}
                </Row>
              </div>

              <Divider text="Spanien" />

              <div className="travel-offer">
                <Row>
                  {offers
                    .filter((offer) => offer.country === "Spanien")
                    .map((offer) => (
                      <Col key={offer.id} xs={12} sm={6} md={4}>
                        <TemplateOffer
                          imgHead={offer.imgHead}
                          title={offer.title}
                          subtitle={offer.subtitle}
                          text={offer.text_overview}
                          price={offer.price}
                          duration={offer.duration}
                          maxGuests={offer.maxGuests}
                          overalleLevel={offer.overalleLevel}
                          onMehrClick={() => handleOfferClick(offer.id)}
                          onBuchenClick={() => handleBookingClick(offer.id)}
                        />
                      </Col>
                    ))}
                </Row>
              </div>

              <Divider text="Bosnien-Herzegowina" />

              <div className="travel-offer">
                <Row>
                  {offers
                    .filter((offer) => offer.country === "Bosnien")
                    .map((offer) => (
                      <Col key={offer.id} xs={12} sm={6} md={4}>
                        <TemplateOffer
                          imgHead={offer.imgHead}
                          title={offer.title}
                          subtitle={offer.subtitle}
                          text={offer.text_overview}
                          price={offer.price}
                          duration={offer.duration}
                          maxGuests={offer.maxGuests}
                          overalleLevel={offer.overalleLevel}
                          onMehrClick={() => handleOfferClick(offer.id)}
                          onBuchenClick={() => handleBookingClick(offer.id)}
                        />
                      </Col>
                    ))}
                </Row>
              </div>


            </div>
          </section>
        ) : (
          <section className="info-offer-section">
            <InfoOffer
              offers={selectedOffer}
              onReturn={handleReturnClick}
              onBook={handleBookingClick}
            />
          </section>
        )}
      </Textsection>

      <NoOfferFound
        heading="Kein passendes Angebot gefunden?"
        description="Kein Problem! Wir planen gerne eine individuelle und einzigartige Reise oder Tour, die ganz auf deine Wünsche zugeschnitten ist. Lass uns deine Vorstellungen wissen, und wir erstellen das perfekte Reiseerlebnis für dich."
        buttonText="Schreib uns!"
        buttonLink="/contact"
      />
    </LayoutMain>
  );
};

export default Travel;
